<div class="sb-stil-wrapper">
        <div *ngIf="state === 'form'" class="sb-page">
                <div class="container py-4">
                        <form #stilNgForm="ngForm" (ngSubmit)="submitStilForm()">
                                <div #stilPdfContent class="stil-pdf-content">
                                        <h2 class="text-center mb-2">
                                                Medical Certificate Evidence for Short Term Incapacity
                                                Leave Application
                                        </h2>

                                        <p class="text-center mb-5 intro-text">
                                                Please complete the following form and attach your sick
                                                leave medical certificate in respect of the specific
                                                application for STIL. The medical certificate MUST
                                                contain an ICD10 code, completed by your doctor, in
                                                order to be a valid certificate for STIL benefits.
                                        </p>

                                        <section class="mb-4">
                                                <label class="form-label">Name <span>*</span></label>

                                                <div class="row g-3 mb-4">
                                                        <div class="col-md-6">
                                                                <input class="form-control" name="firstName"
                                                                        placeholder="First"
                                                                        [(ngModel)]="stilForm.firstName" required />
                                                        </div>

                                                        <div class="col-md-6">
                                                                <input class="form-control" name="lastName"
                                                                        placeholder="Last"
                                                                        [(ngModel)]="stilForm.lastName" required />
                                                        </div>
                                                </div>

                                                <div class="row g-4 mb-4">
                                                        <div class="col-md-6">
                                                                <label class="form-label">
                                                                        Sick Leave Application Date From
                                                                        <span>*</span>
                                                                </label>

                                                                <input class="form-control" type="date"
                                                                        name="sickLeaveDateFrom"
                                                                        [(ngModel)]="stilForm.sickLeaveDateFrom"
                                                                        required />
                                                        </div>

                                                        <div class="col-md-6">
                                                                <label class="form-label">
                                                                        Sick Leave Application Date To
                                                                        <span>*</span>
                                                                </label>

                                                                <input class="form-control" type="date"
                                                                        name="sickLeaveDateTo"
                                                                        [(ngModel)]="stilForm.sickLeaveDateTo"
                                                                        required />
                                                        </div>
                                                </div>

                                                <div class="row g-4 mb-4">
                                                        <div class="col-md-4">
                                                                <label class="form-label">
                                                                        ID Number or Passport Number
                                                                        <span>*</span>
                                                                </label>

                                                                <input class="form-control" name="idNumber"
                                                                        [(ngModel)]="stilForm.idNumber" required />
                                                        </div>

                                                        <div class="col-md-4">
                                                                <label class="form-label">
                                                                        Email <span>*</span>
                                                                </label>

                                                                <input class="form-control" type="email"
                                                                        name="emailAddress"
                                                                        [(ngModel)]="stilForm.emailAddress" required />
                                                        </div>

                                                        <div class="col-md-4">
                                                                <label class="form-label">
                                                                        Cell Phone Number <span>*</span>
                                                                </label>

                                                                <input class="form-control" name="cellPhoneNumber"
                                                                        [(ngModel)]="stilForm.cellPhoneNumber"
                                                                        required />
                                                        </div>
                                                </div>
                                        </section>

                                        <section class="mb-5">
                                                <label class="form-label">
                                                        Upload Sick Leave Medical Certificate Here
                                                </label>

                                                <input class="form-control file-input" type="file"
                                                        name="sickLeaveMedicalCertificate"
                                                        (change)="onSingleFileSelected($event)" required />
                                        </section>

                                        <section class="mb-5">
                                                <h4>Confidentiality and POPIA</h4>

                                                <p class="fw-semibold">
                                                        Processing of Personal Information in terms of the
                                                        Protection of Personal Information Act 4 of 2013
                                                </p>

                                                <p>
                                                        The privacy of our clients is of utmost importance
                                                        to us. We will take the necessary measures to ensure
                                                        that any and all information, including Personal
                                                        Information, provided by you or which is collected
                                                        from you is processed in accordance with the
                                                        provisions of the Protection of Personal Information
                                                        Act 4 of 2013 and further, is stored in a safe and
                                                        secure manner.
                                                </p>

                                                <p class="fw-semibold">
                                                        The Client's Personal Information will ONLY be used
                                                        to assess the application for STIL.
                                                </p>

                                                <p>
                                                        You acknowledge that any Personal Information
                                                        supplied to us in respect of yourself is provided
                                                        according to the Applicable Laws. Unless consented to
                                                        by yourself, we will not sell, exchange, transfer,
                                                        rent or otherwise make available any Personal
                                                        Information you have provided in respect of our
                                                        Insured unless it is a requirement in terms of the
                                                        Applicable Laws.
                                                </p>

                                                <label class="form-label fw-semibold">
                                                        I acknowledge that I have read, understood and agree
                                                        with the Confidentiality and POPIA Statement
                                                        <span>*</span>
                                                </label>

                                                <select class="form-select popia-select" name="popiaConsent"
                                                        [(ngModel)]="stilForm.popiaConsent" required>
                                                        <option value=""></option>
                                                        <option value="Yes">Yes</option>
                                                        <option value="No">No</option>
                                                </select>
                                        </section>

                                        <section class="mb-5">
                                                <div class="row g-4">
                                                        <div class="col-md-6">
                                                                <label class="form-label">
                                                                        Signature <span>*</span>
                                                                </label>

                                                                <div class="signature-wrapper">
                                                                        <canvas #signatureCanvas
                                                                                class="signature-canvas"
                                                                                (mousedown)="startDrawing($event)"
                                                                                (mousemove)="draw($event)"
                                                                                (mouseup)="stopDrawing()"
                                                                                (mouseleave)="stopDrawing()"
                                                                                (touchstart)="startDrawing($event)"
                                                                                (touchmove)="draw($event)"
                                                                                (touchend)="stopDrawing()">
                                                                        </canvas>

                                                                        <input type="hidden" name="signatureData"
                                                                                [(ngModel)]="stilForm.signatureData"
                                                                                required />

                                                                        <div
                                                                                class="d-flex justify-content-between mt-2">
                                                                                <small class="text-muted">
                                                                                        Sign inside the box above
                                                                                </small>

                                                                                <button type="button"
                                                                                        class="btn btn-sm btn-outline-secondary"
                                                                                        (click)="clearSignature()">
                                                                                        Clear Signature
                                                                                </button>
                                                                        </div>
                                                                </div>
                                                        </div>

                                                        <div class="col-md-6">
                                                                <label class="form-label">
                                                                        Date <span>*</span>
                                                                </label>

                                                                <input class="form-control" type="date"
                                                                        name="signatureDate"
                                                                        [(ngModel)]="stilForm.signatureDate" required />
                                                        </div>
                                                </div>
                                        </section>
                                </div>

                                <div class="d-flex justify-content-start pb-5">
                                        <button type="submit" class="btn btn-danger"
                                                [disabled]="stilNgForm.invalid || isSubmitting">
                                                Submit
                                        </button>
                                </div>
                        </form>
                </div>
        </div>

        <div *ngIf="state === 'completed'" class="auth-card">
                <div class="text-center header-section">
                        <h2 class="title">Submission Completed</h2>

                        <p class="subtitle">
                                Thank you. Your STIL medical certificate evidence has been
                                received.
                        </p>

                        <div class="mt-4 text-start border rounded p-3 bg-light">
                                <p class="mb-2">
                                        <strong>Case Reference:</strong>
                                        <span>{{ completedCaseReference || 'Pending' }}</span>
                                </p>

                                <p class="mb-0">
                                        <strong>Case Type:</strong>
                                        <span>{{ completedCaseType }}</span>
                                </p>
                        </div>

                        <p class="text-muted mt-3 mb-0">
                                Please keep this case reference for future follow-up.
                        </p>
                </div>
        </div>
</div>